import React, { useContext } from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useNavigate } from 'react-router-dom';
import InfoButtonWithPopover from "./InfoButtonWithPopover";
import { AuthContext } from '../context/authContext';

const TablaRed = ({ data, isLoading,
    //setRegistro,
    onEditarRegistro,
    setNewEditandoId,  handlePreviewClick, arrayEditando, handleIsEditing 
}) => { //rowInforme
    console.log("Datos en TablaInicio:", data); // Verifica que los datos lleguen
    console.log("ARRAY EDITANDO", arrayEditando)
    const {user, role, userMunicipio} = useContext(AuthContext)
    console.log("USER", user)
    const isVisualizador = role === 'visualizador_municipio';
    const navigate = useNavigate();

    if (isLoading) {
        return (
            <div className="flex justify-center items-center p-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    if (data.length === 0) {
        return (
            <div className="text-center py-8 text-gray-500">
                No se encontraron registros que coincidan con los filtros seleccionados.
            </div>
        );
    }

    // Función para formatear fechas
    const formatearFecha = (fecha) => {
        if (!fecha) return 'N/A';
        try {
            // Asegurarse de que la fecha sea un objeto Date válido
            const fechaObj = new Date(fecha);
            if (isNaN(fechaObj.getTime())) return 'Fecha inválida';
            
            return format(fechaObj, "dd/MM/yyyy", { locale: es });
        } catch (error) {
            console.error('Error al formatear fecha:', error);
            return 'N/A';
        }
    };

    const handleRowClick = (row, isEditing) => {
        console.log("ROW CLICKED", row)
        console.log("que recibe en IS EDITING", isEditing) //siempre es tru
        //if isEditing status es 'edit'
        /*let status;
        if(isEditing===true){
            status = 'edit'
        }else{
            status = 'edit'
        }*/
        onEditarRegistro(row)// cambiamos ---->setRegistro(row)
        setNewEditandoId(row.id_red)
        handleIsEditing(isEditing)
    }

    const handleIrMapa = (item) => {
        navigate('/mapa-privado', {
            state: {
                geom_sede: item.geom_sede,
                geom_parcela: item.geom_parcelas,
                codigo_partido: item.codigo_partido,
                partido_nombre: item.partido_nombre,
                id_red: item.id_red,
                nombre_completo: item.nombre_completo
            }
        });
    };

    // Función para verificar si una fila está siendo editada
    const isRowBeingEdited = (obraId) => {
        // Si el array está vacío, retornar falso inmediatamente
        /*if (!arrayEditando || arrayEditando.length === 0) {
            return false;
        }*/

         // Asegurarse de que arrayEditando sea un array
        const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];
        // Verificar si la obra está siendo editada por otro usuario
        const isEditing = safeArray.some(objeto => {
            // Verificar que el objeto tenga las propiedades necesarias
            if (!objeto || !objeto.id_edit || !objeto.user_edit || !objeto.status) {
                return false;
            }
            // Limpiamos las comillas dobles de user_edit para la comparación
            const userEditClean = objeto.user_edit.replace(/"/g, '');
            return objeto.id_edit === obraId && objeto.status === 'editando'; //&& userEditClean !== user 
        });
        
        //console.log("IS EDITING", isEditing)
        return isEditing;
        //return arrayEditando[obraId]?.length > 0;
    };

    //funcion para verificar si ademas es 'solo_lectura'
    const isRowBeingReadOnly = (obraId) => {
        // Si el array está vacío, retornar falso inmediatamente
        /*if (!arrayEditando || arrayEditando.length === 0) {
            return false;
        }*/

         // Asegurarse de que arrayEditando sea un array
        const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];
        // Verificar si la obra está siendo editada por otro usuario
        const isReadOnly = safeArray.some(objeto => {
            // Verificar que el objeto tenga las propiedades necesarias
            if (!objeto || !objeto.id_edit || !objeto.user_edit || !objeto.status) {
                return false;
            }
            // Limpiamos las comillas dobles de user_edit para la comparación
            const userEditClean = objeto.user_edit.replace(/"/g, ''); //HACE falta??
            return objeto.id_edit === obraId && userEditClean !== user && objeto.status === 'solo_lectura';
        });
        
        //console.log("IS EDITING", isEditing)
        return isReadOnly;
        //return arrayEditando[obraId]?.length > 0;
    };

    // Función para obtener el texto del tooltip - 
    //NOTA: resolver primero como quitar usuarios del arrayEditando para que no muestre  Javier y Datos
    
    const getEditingTooltip = (obraId) => {
        try {
            const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];

            //Verificar si hay id_edit con status 'editando' y 'solo_lectura' y devolver el user_edit
            const editando = safeArray.find(item => item && item.id_edit === obraId && item.status === 'editando');
            const soloLectura = safeArray.find(item => item && item.id_edit === obraId && item.status === 'solo_lectura');

            if (editando && soloLectura) {
                return `Editando usuario: ${editando.user_edit} - Solo lectura: ${soloLectura.user_edit}`;
            } else if (soloLectura) {
                return `Solo lectura: ${soloLectura.user_edit}`;
            } else if (editando){
                return `Editando usuario: ${editando.user_edit}`;
            }
           
        } catch (error) {
            console.error('Error en getEditingTooltip:', error);
            return '';
        }
    };

    return (
        <div className="shadow overflow-hidden border-b border-gray-200 dark:border-gray-700 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead className="bg-gray-50 dark:bg-gray-800">
                    <tr>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            ID red
                        </th>                        
                        
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Nombre
                        </th>

                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Partido
                        </th>
                        
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Geo Sede
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Geo Parcelas
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Acciones
                        </th>
                        
                    </tr>
                </thead>
                <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
                    {data.map((item, index) => {
                        const isEditing = isRowBeingEdited(item.id_partido_obra);
                        console.log("IS EDITING", index, isEditing)

                        //si tiene status solo_lectura crear una constante isReadOnly
                        const isReadOnly = isRowBeingReadOnly(item.id_partido_obra);
                        //console.log("IS ReadOnly", index, isEditing)
                        const editingTooltip = getEditingTooltip(item.id_partido_obra);
                        
                        let georeferenceSede;
                        const sinSede = item.sin_sede === true;
                        if (sinSede) {
                            georeferenceSede = 'sin_sede';
                        } else if(item.geom_sede !== null) {
                            georeferenceSede = true;
                        } else {
                            georeferenceSede = false;
                        }

                        let georeferenceParcelas;
                        if(item.geom_parcelas && item.geom_parcelas.length > 0 && item.geom_parcelas[0]?.geometry !== null) {
                            georeferenceParcelas = true;
                        } else {
                            georeferenceParcelas = false;
                        }

                        return (
                            <tr
                                key={item.id || index}
                                //className="hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer transition-colors duration-150"
                                // Agregar manejador de clic si es necesario
                                //un estilo por defecto, un estilo para cuando se edita, un estilo solo lectura y un estilo para cuando se edita y se lee
                                className={`hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer transition-colors duration-150 ${(isEditing === true && isReadOnly === true)
                                        ? 'hover:bg-red-200 bg-red-200 dark:hover:bg-red-200/20 dark:bg-red-200/20 dark:border-l-4 dark:border-l-red-200'
                                        : ''
                                    } ${(isReadOnly === true && isEditing === false)
                                        ? 'hover:bg-yellow-200 bg-yellow-200 dark:hover:bg-yellow-200/20 dark:bg-yellow-200/20 dark:border-l-4 dark:border-l-yellow-200'
                                        : ''
                                    } ${(isEditing === true && isReadOnly === false)
                                        ? 'hover:bg-red-200 bg-red-200 dark:hover:bg-red-200/20 dark:bg-red-200/20 dark:border-l-4 dark:border-l-red-200'
                                        : ''
                                    }`}
                                title={editingTooltip} //NO USAR POR AHORA
                                onDoubleClick={() => handleRowClick(item, isEditing)}
                            >
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {item.id_red || 'N/A'}
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                        {item.nombre_completo || 'N/A'}
                                </td>
                                
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {item.partido_nombre || 'N/A'}
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span className={`inline-flex items-center gap-2 px-2 py-1 rounded text-xs font-semibold ${
                                        georeferenceSede === true ? 'bg-[#50bb47] text-white' : 
                                        georeferenceSede === 'sin_sede' ? 'bg-gray-400 text-white' : 
                                        'bg-[#e01f20] text-white'
                                    }`}>
                                        {georeferenceSede === true ? (
                                            <><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>Si</>
                                        ) : georeferenceSede === 'sin_sede' ? (
                                            <><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M20 12H4" /></svg>Sin sede</>
                                        ) : (
                                            <><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" /></svg>No</>
                                        )}
                                    </span>
                                </td> 
                                
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span className={`inline-flex items-center gap-2 px-2 py-1 rounded text-xs font-semibold ${georeferenceParcelas ? 'bg-[#50bb47] text-white' : 'bg-[#e01f20] text-white'}`}>
                                        {georeferenceParcelas ? (
                                            <><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>Si</>
                                        ) : (
                                            <><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" /></svg>No</>
                                        )}
                                    </span>
                                </td> 
                                
                               
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                    {isVisualizador ? (
                                        <button
                                            onClick={() => handleRowClick(item, isEditing)}
                                            disabled={item.codigo_partido !== userMunicipio}
                                            title={item.codigo_partido !== userMunicipio ? 'Solo puede visualizar entidades de su municipio' : 'Visualizar entidad'}
                                            className={`font-bold py-2 px-4 rounded mr-2 ${
                                                item.codigo_partido === userMunicipio
                                                    ? 'bg-[#476c97] hover:bg-blue-700 text-white'
                                                    : 'bg-gray-400 cursor-not-allowed text-gray-200'
                                            }`}
                                        >
                                            Visualizar
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => handleRowClick(item, isEditing)}
                                            className="bg-[#476c97] hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
                                        >
                                            Editar
                                        </button>
                                    )}
                                    <button 
                                        onClick={() => handleIrMapa(item)} 
                                        disabled={georeferenceSede !== true && !georeferenceParcelas}
                                        className={`font-bold py-2 px-4 rounded ${
                                            georeferenceSede === true || georeferenceParcelas
                                                ? 'bg-[#476c97] hover:bg-blue-700 text-white'
                                                : 'bg-gray-400 cursor-not-allowed text-gray-200'
                                        }`}
                                    >
                                        Mapa
                                    </button>
                                    {/*<button onClick={() => handlePreviewClick(item)}>
                                        Previsualizar
                                    </button>
                                    <InfoButtonWithPopover infoText="EN DESARROLLO." />*/}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default TablaRed;
